import React, { useState, useEffect } from "react";
import { Modal, Spinner } from "reactstrap";
import { Button, TextField } from "shared";
import "./twoFa.scss";
import ApiCaller from "../../api/apiCaller";

type ModalTwoFactorProps = {
  isOpen: boolean;
  toggle: (event?: React.KeyboardEvent<any>) => void;
  userId: number;
  handleLogin: (res: any) => void;
};
let code = "";
const ModalTwoFactor = ({
  isOpen,
  toggle,
  userId,
  handleLogin,
}: ModalTwoFactorProps) => {
  const [loading, setLoading] = useState(false);
  const apply = async () => {
    setLoading(true);
    const res = await ApiCaller.post("user/login2FA", {
      token: code,
      user_id: userId,
    });
    setLoading(false);
    if (res.message) {
      alert(res.message);
    } else {
      handleLogin(res);
    }
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} style={{ padding: 30 }}>
      <div className="two-factor__header">
        <span className="two-factor__header__title">
          Nhập mã xác nhận được tạo từ ứng dụng di động của bạn
        </span>
      </div>
      <div className="two-factor__body">
        <TextField
          placeholder="Mã xác nhận"
          type="outline"
          style={{ width: "100%" }}
          onChange={(e) => {
            code = e.target.value;
          }}
          autoFocus
        />
      </div>
      <div className="two-factor__footer">
        <div className="two-factor__confirm-button" onClick={apply}>
          {(loading && <Spinner size="sm" color="light" />) || (
            <span>Xác nhận</span>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ModalTwoFactor;
